import { CircularProgress } from '@material-ui/core'
import amexIcon from 'assets/img/amex.svg'
import checkedIcon from 'assets/img/checked.svg'
import CrossIcon from 'assets/img/cross.svg'
import dinnersIcon from 'assets/img/dinners.svg'
import discoverIcon from 'assets/img/discover.svg'
import GientLeap from 'assets/img/giantLeapPlus.svg'
import IPhoneMockup from 'assets/img/iPhone-mockup.svg'
import jcbIcon from 'assets/img/jcb.svg'
import mastercardIcon from 'assets/img/mastercard.svg'
import stripeTag from 'assets/img/stripe_tag.svg'
import unionPayIcon from 'assets/img/unionPay.svg'
import visaIcon from 'assets/img/visa.svg'
import classnames from 'classnames'
import { PaymentSaveCardComponent } from 'components'
// import { IPopoverButtonOptions } from 'components/PopoverButton'
// import { supportEmail } from 'config'
import { EventEmitter } from 'events'
import * as React from 'react'
import 'react-phone-input-2/lib/style.css'
import ReactSVG from 'react-svg'
import { _route } from 'routes/config'
// import { clearPlusUser } from 'services/plusUsers'
// import SnackbarService from 'services/snackbars'
import styles from './style.module.scss'

interface IProps {
  parentId: string
  parentName: string
  parentEmail: string
  upgradeUser: () => void
  history: any
  onClose: () => void
  fontSize: string
  user: any
  UserLib: any
  PatientsLib: any
  PlusUserLib: any
  isMobile: boolean
}

export const PlusComponent: React.FC<IProps> = ({
  parentId,
  parentName,
  parentEmail,
  upgradeUser,
  history,
  fontSize,
  onClose
}: IProps) => {
  const [showPaymentTab, setShowPaymentTab] = React.useState(true)
  const [isLoadingPayment, setLoadingPayment] = React.useState(false)
  const [isDisabledPayment, setIsDisabledPayment] = React.useState(false)
  const [checkoutEvent] = React.useState(new EventEmitter())

  const checkoutTrigger = () => {
    checkoutEvent.emit('checkout')
  }

  // const popoverProps: IPopoverButtonOptions[] = [
  //   {
  //     key: 'feedback',
  //     label: 'Contact Support',
  //     onClick: () =>
  //       (window.location.href = `mailto:${supportEmail}?subject=GiantLeap%20Support%20Ticket`)
  //   },
  //   {
  //     key: 'logout',
  //     label: 'Sign Out',
  //     onClick: () => {
  //       UserLib.logout(
  //         () => {
  //           PatientsLib.clear()
  //           clearPlusUser(PlusUserLib)
  //           const landing = process.env.REACT_APP_LANDING_URL
  //           if (landing) {
  //             window.location.href = landing
  //           }
  //         },
  //         (message: string) => {
  //           SnackbarService.showSnackbar('Error while logging out', 'error')
  //           console.error(`Error while logging out: ${message}`)
  //         }
  //       )
  //     }
  //   }
  // ]

  const goToCongratulationsTab = () => history.replace('/confirmation')

  const getDescriptionTabItem = (content: string) => (
    <div className={styles.item}>
      <ReactSVG className={styles.item__icon} src={checkedIcon} />
      <div className={styles.item__text}>{content}</div>
    </div>
  )

  const getDescriptionTab = () => {
    return (
      <div className={styles.features}>
        <div className={styles.featuresTitle}>
          <div className={styles.featuresTitle__text}>
            Description All Features
          </div>
          <div className={styles.discountIcon}>
            <div className={styles.discountIcon__text}>50% off</div>
          </div>
        </div>
        <div className={styles.items}>
          {getDescriptionTabItem(
            'Description all the evaluation games and questionnaires'
          )}
          {getDescriptionTabItem(
            `Unlock all the scores in your child's abilities map`
          )}
          {getDescriptionTabItem(
            'Get detailed explanations of every ability and how it relates to your child’s day-to-day'
          )}
          {getDescriptionTabItem(
            'Receive premium support from our dedicated team'
          )}
        </div>
        <div className={styles.buttonContainer}>
          <div className={styles.button}>
            <button
              className={styles.button__inner}
              onClick={() => setShowPaymentTab(true)}
              id="2-buynow-a"
            >
              Buy Now
            </button>
          </div>
          <div className={styles.buyPrice}>
            <div className={styles.buyPrice__price}>$49.99</div>
            <div className={styles.buyPrice__discount}>$99.99</div>
          </div>
        </div>
        <div className={styles.comment}>
          <span className={styles.comment__star}>*</span>
          Your purchase includes one full evaluation per child
        </div>
      </div>
    )
  }

  const getPaymentTab = () => {
    return (
      <div className={styles.card}>
        <div className={styles.title}>
          <div className={styles.title__text}>Payment Details</div>
          <ReactSVG className={styles.title__tag} src={stripeTag} />
        </div>
        <PaymentSaveCardComponent
          goToCongratulationsTab={() => goToCongratulationsTab()}
          parentId={parentId}
          parentName={parentName}
          parentEmail={parentEmail}
          upgradeUser={upgradeUser}
          fontSize={fontSize}
          checkoutEvent={checkoutEvent}
          setLoading={setLoadingPayment}
          setDisabled={setIsDisabledPayment}
          disabled={isDisabledPayment}
        />
        <div className={styles.price}>
          <div
            className={classnames(
              styles.price__section,
              styles.price__section_sub
            )}
          >
            <p>Subtotal</p>
            <p>$99.99</p>
          </div>
          <div
            className={classnames(
              styles.price__section,
              styles.price__section_discount
            )}
          >
            <p>Early adopter discount</p>
            <p>-$50.00</p>
          </div>
          <div
            className={classnames(
              styles.price__section,
              styles.price__section_border
            )}
          />
          <div
            className={classnames(
              styles.price__section,
              styles.price__section_total
            )}
          >
            <p>Total billed today</p>
            <p>$49.99</p>
          </div>
          <div className={styles.methods}>
            <div className={styles.methods__title}>
              Accepted payment methods
            </div>
            <div className={styles.methods__items}>
              {[
                visaIcon,
                amexIcon,
                mastercardIcon,
                dinnersIcon,
                unionPayIcon,
                discoverIcon,
                jcbIcon
              ].map((srcIcon, key) => (
                <div key={String(key)}>
                  <ReactSVG src={srcIcon} />
                </div>
              ))}
            </div>
          </div>

          {isLoadingPayment ? (
            <div className={styles.loading}>
              <CircularProgress size={60} />
            </div>
          ) : (
            <div className={styles.checkout}>
              <button
                className={styles.checkout__button}
                type="submit"
                onClick={checkoutTrigger}
                disabled={isDisabledPayment}
              >
                Upgrade Now
              </button>
            </div>
          )}
        </div>
      </div>
    )
  }

  return (
    <div className={styles.wrap}>
      <div className={styles.wrap__content}>
        <div className={styles.popup}>
          <div
            className={classnames(
              styles.popup__leftSection,
              showPaymentTab && styles.popup__leftSection_card
            )}
          >
            <ReactSVG className={styles.giantLeapIcon} src={GientLeap} />

            {showPaymentTab ? getPaymentTab() : getDescriptionTab()}
          </div>
          <div className={styles.popup__rightSection}>
            <div className={styles.phone}>
              <ReactSVG className={styles.phone__item} src={IPhoneMockup} />
            </div>
          </div>
        </div>
      </div>
      <div
        className={styles.crossIcon}
        onClick={() => {
          onClose()
        }}
      >
        <ReactSVG src={CrossIcon} />
      </div>
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/pages/Payment/PlusComponent/index.tsx